import React from 'react';
import styled from 'styled-components';



/*

Props:


*/

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  background-color: ${props => (props.color) ? props.color : 'red'};
  border-radius: 100%;
  width: ${props => (props.size) ? props.size : 'auto'};
  height: ${props => (props.size) ? props.size : 'auto'};
  padding:  ${props => (props.padding) ? props.padding : '0 0 0 0'};
`;

const IconCircleWrapperSC = ({ styles, children, onClick, ...rest }) => (
  <StyledDiv style = {styles} onClick = {onClick} {...rest} >
      { children }
  </StyledDiv>
)

export default IconCircleWrapperSC





// WEBPACK FOOTER //
// ./src/js/components/Icons/Wrappers/IconCircleWrapperSC.jsx